import { ResetPasswordForm } from "@/components/reset-password-form";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/password/change/")({
  validateSearch: z.object({
    token: z.string().optional(),
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { token } = Route.useSearch();
  return <ResetPasswordForm token={token} />;
}
